import { Component, OnInit, ViewChild, AfterViewInit, Inject, Injectable, OnDestroy } from '@angular/core';
import { UserService } from './services/user.service';
import { DialogService } from './services/dialog.service';
import { ApiService } from './services/api.service';
import { Router, NavigationEnd, ActivatedRoute, ActivationStart } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Location, DOCUMENT, ViewportScroller } from '@angular/common';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';


import { PlayerService } from './services/player.service';
import { GlobalService } from './services/global.service';
import { RegisterService } from './services/register.service';

import {SchemaService} from './services/schema.service'
import { Observable, Subscribable, Subscription } from 'rxjs';

import * as $ from 'jquery';
import { SwUpdate } from '@angular/service-worker';
import { ExitPopUpComponent } from './components/exit-pop-up/exit-pop-up.component';
import { GuidedTour, GuidedTourComponent, GuidedTourService, Orientation } from 'ngx-guided-tour';
import { animate, group, query, stagger, state, style, transition, trigger } from '@angular/animations';
import { CommonService } from './profile/common.service';
import { filter } from 'rxjs/operators';





@Component({
    selector: 'sd-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [


        trigger('visitorDistibute', [

            transition(':enter', [
                group([
                    query('.distribute', [
                        style({
                            right: '95px',
                            bottom: '195px',
                        }),
                        animate(100)

                    ]),
                    query('.visitorDistribute', [
                        style({
                            width: '96px',
                            height: '96px',
                            bottom: 'calc(175px - 48px)',
                            right: 'calc(110px - 48px)'
                        }),
                        animate(100)

                    ]),
                    query('.visitorPromote', [style({ opacity: '0' })]),
                    query('.visitorMonetisation', [style({ opacity: '0' })]),
                ]),
                group([
                    query('.promote', [
                        style({
                            right: '90px',
                            bottom: '149px'
                        }),
                        animate(150)
                    ]),
                    query('.visitorPromote', [
                        style({
                            width: '120px',
                            height: '120px',
                            right: 'calc(110px - 60px)',
                            bottom: 'calc(175px - 60px)',
                            opacity: '1'
                        }),
                        animate(150)
                    ]),
                    query('.visitorMonetisation', [style({ opacity: '0' })]),

                ]),
                group([
                    query('.monetisation', [
                        style({
                            right: '95px',
                            bottom: '98px'
                        }),
                        animate(150)
                    ]),
                    query('.visitorMonetisation', [
                        style({
                            width: '150px',
                            height: '150px',
                            right: 'calc(110px - 75px)',
                            bottom: 'calc(175px - 75px)',
                            opacity: 1,
                        }),
                        animate(150)
                    ])
                ])
            ]),
            transition(':leave', [
                group([
                    query('.monetisation', [
                        animate(150, style({
                            right: '95px',
                            bottom: '98px',
                            opacity: 0
                        }))
                    ]),
                    query('.visitorMonetisation', [
                        animate(150, style({
                            width: '150px',
                            height: '150px',
                            right: 'calc(110px - 75px)',
                            bottom: 'calc(175px - 75px)',
                            opacity: 0,
                        }))
                    ])
                ]),
                group([
                    query('.promote', [

                        animate(150, style({
                            right: '90px',
                            bottom: '149px',
                            opacity: 0,
                        }))
                    ]),
                    query('.visitorPromote', [
                        animate(150, style({
                            width: '120px',
                            height: '120px',
                            right: 'calc(110px - 60px)',
                            bottom: 'calc(175px - 60px)',
                            opacity: 0
                        }))
                    ]),

                ]),
                group([
                    query('.distribute', [


                        animate(100, style({
                            right: '95px',
                            bottom: '195px',
                            opacity: 0,
                        }))

                    ]),
                    query('.visitorDistribute', [


                        animate(100, style({
                            width: '96px',
                            height: '96px',
                            bottom: 'calc(175px - 48px)',
                            right: 'calc(110px - 48px)',
                            opacity: 0
                        }))

                    ]),
                ]),
                group([
                    query('.mbaLogo', [
                        animate(300, style({
                            width: '64px',
                            height: '64px',
                            right: 'calc(110px - 32px)',
                            bottom: 'calc(175px - 32px)',
                            // opacity: 0

                        }))
                    ]),
                    query('.mbaLogoImg', [
                        animate(300, style({
                            width: '54px',
                            height: '30px',
                            padding: '16px 5px',
                            right: 'calc(110px - 27px)',
                            bottom: 'calc(175px - 15px',
                            // opacity: 0
                        }))
                    ])

                ])


            ]),
        ]),
        trigger('mobileMbaLogo', [
            transition(':enter', [
                style({
                    opacity: 0
                }),
                animate(700, style({
                    opacity: 0
                })),


            ])
        ])
    ]






})


@Injectable({ providedIn: 'root' })


export class AppComponent implements OnInit, AfterViewInit {

    //values = JSON.parse(localStorage.getItem("token"))


    @ViewChild('drawer') sidenav: any;
    embed: Boolean = false;

    pageType = '';
    navigationType = '';

    searchResults = [];
    search = '';
    searchApi: any;
    isVisitStart = false;
    isMobileVisitStar = false;
    mbaTextState = 'large';
    widgetStart = false;
    subIsVisitor: Subscription;
    subIsMobileVisitStar: Subscription;
    subWidgetStart: Subscription;
    // showPlayer: boolean = false;
    notificationsLoaded: Boolean = false;
    notifications = [];
    showWidget = true;
    listenerRoutes = [];
    artistWithAccess = [];
    searchSub: any;

    boldTag = /\<b\>/gi;
    boldCloseTag = /\<\/b\>/gi;

    schemaData: any;

    showShoskele = false;
    shoskeleMedia = [];
    shoskeleBanner: any;
    shoskeleTimeout: any;

    broadcastVideoTab = false;
    mySongdewTab = false;
    myMusicTab = false;
    profileTab = false;
    discoverTab = false;
    discover2Tab = false;
    showUnread: Boolean = false;
    loadData: Boolean = false;
    noti_count: number = 0;
    brd_count: number = 0;
    openDropdown: string | null = null;


    constructor(
        private api: ApiService,
        public comService: CommonService,
        public user: UserService,
        public dialog: DialogService,
        public router: Router,
        public player: PlayerService,
        private route: ActivatedRoute,
        public global: GlobalService,
        private location: Location,
        private register: RegisterService,
        private swUpdate: SwUpdate,
        public dialogRef: MatDialog,
        private schemaService: SchemaService,
        @Inject(DOCUMENT) private document: Document,

        private guidedTourService: GuidedTourService,
        private guidedTourComponent: GuidedTourComponent,
        private scroller: ViewportScroller

    ) {
        if (this.location.path().indexOf('/embed/') > -1) {
            this.embed = true;
        }


        this.route.queryParams.subscribe(res => {
            if (res.login != undefined && res.login != null && res.login != '' && res.login != '/') {
                if (user.status > 0) {
                    this.router.navigate([res.login], { queryParams: { login: null }, queryParamsHandling: 'merge' });
                } else {
                    this.dialog.openLoginDialog(res.register ? 2 : 1, '', 'sign-in', res.login);
                }
            }

            if (this.user.status == 0) {
                localStorage.removeItem('token');
                localStorage.removeItem('isProMember');
                localStorage.clear();

                const provider = res.provider;
                const access_token = res.access_token;
                const redirect_url = res.redirect_url;

                if ((provider == 'FACEBOOK' || provider == 'GOOGLE') && access_token != undefined && access_token != null && redirect_url != undefined && redirect_url != null) {
                    this.global.globalSpinner = true;

                    this.api.sociaLogin(access_token, provider, '').subscribe(res => {
                        // console.log(res);
                        this.global.globalSpinner = false;

                        if (res.success) {
                            this.user.category = res.category;
                            this.user.token = 'Token ' + res.result.token;
                            this.user.id = res.result.id;
                            this.user.type = res.result.is_type;
                            this.user.slug = res.result.slug_username;
                            this.user.fname = res.result.profile.first_name;
                            this.user.lname = res.result.profile.last_name;
                            this.user.dp = res.result.profile.profile_pic;
                            this.user.cover = res.result.profile.cover_pic;
                            this.user.isProMember = res.result.is_pro;
                            this.user.genre = [];
                            res.result.genre_id.forEach(genre => {
                                this.user.genre.push(genre.name);
                            });

                            this.user.artistType = [];
                            res.result.artist_type.forEach(type => {
                                this.user.artistType.push(type.name);

                                if (type.name.toLowerCase() == 'band') {
                                    this.user.type = 'Band';
                                }
                            });

                            this.user.mobile = res.result.mobile;
                            this.user.email = res.result.email;
                            this.user.isEmailVerified = res.result.ismail_verify;
                            this.user.isMobVerified = res.result.ismobile_verify;
                            this.user.songsCount = res.result.songs_count;
                            this.user.videosCount = res.result.videos_count;
                            this.user.isPwdSet = res.result.has_usable_password;

                            if (this.user.type == 'Band') {
                                this.user.status = 2;
                            } else if (this.user.type == 'Artist') {
                                this.user.status = 1;
                            } else if (this.user.type == 'Listener') {
                                this.user.status = 3;
                            }

                            this.user.name = this.user.fname + ' ' + this.user.lname;

                            localStorage.setItem('category', JSON.stringify(this.user.category));
                            localStorage.setItem('token', JSON.stringify(this.user.token));
                            localStorage.setItem('id', JSON.stringify(this.user.id));
                            localStorage.setItem('type', JSON.stringify(this.user.type));
                            localStorage.setItem('slug', JSON.stringify(this.user.slug));
                            localStorage.setItem('fname', JSON.stringify(this.user.fname));
                            localStorage.setItem('lname', JSON.stringify(this.user.lname));
                            localStorage.setItem('dp', JSON.stringify(this.user.dp));
                            localStorage.setItem('cover', JSON.stringify(this.user.cover));
                            localStorage.setItem('genre', JSON.stringify(this.user.genre));
                            localStorage.setItem('artistType', JSON.stringify(this.user.artistType));
                            localStorage.setItem('mobile', JSON.stringify(this.user.mobile));
                            localStorage.setItem('email', JSON.stringify(this.user.email));
                            localStorage.setItem('isEmailVerified', JSON.stringify(this.user.isEmailVerified));
                            localStorage.setItem('isMobVerified', JSON.stringify(this.user.isMobVerified));
                            localStorage.setItem('songsCount', JSON.stringify(this.user.songsCount));
                            localStorage.setItem('videosCount', JSON.stringify(this.user.videosCount));
                            localStorage.setItem('isPwdSet', JSON.stringify(this.user.isPwdSet));
                            localStorage.setItem('isProMember', JSON.stringify(this.user.isProMember));

                            if (res.result.is_new_user) {
                                this.global.trackEvent('Registration', 'Register-Success', 'Facebook - ' + res.result.id);
                            } else {
                                this.global.trackEvent('Login', 'Login-Success', 'Facebook - ' + res.result.id);
                            }

                            if (
                                (res.result.is_show_update_form || this.user.email == '' || this.user.email == undefined || this.user.email == null)
                            ) {
                                this.register.register_from = 2;
                                this.register.from = this.router.url.split('?')[0];
                                this.register.email = this.user.email;
                                this.register.fname = this.user.fname;
                                this.register.lname = this.user.lname;
                                this.register.token = this.user.token;
                                this.register.username = this.user.slug;

                                this.register.access_token = access_token;
                                this.register.provider = provider;
                                this.register.update = true;

                                this.router.navigate(['/register'], {
                                    queryParamsHandling: 'merge'
                                });
                            } else {
                                const activeRouterPath = redirect_url;
                                const is_new_user = res.result.is_new_user;

                                if (
                                    (activeRouterPath.indexOf('opportunity') > -1 || activeRouterPath.indexOf('opportunities') > -1)
                                ) {
                                    if (is_new_user) {
                                        this.global.trackEvent('Registration', 'Success-landing-page', activeRouterPath);
                                    }

                                    // this.global.reload();
                                    this.router.navigate([activeRouterPath]);
                                } else {
                                    if (this.user.type == 'Listener') {
                                        if (is_new_user) {
                                            this.global.trackEvent('Registration', 'Success-landing-page', '/songs');
                                        }

                                        this.router.navigate(['/songs']);
                                    } else {
                                        if (is_new_user) {
                                            this.global.trackEvent('Registration', 'Success-landing-page', '/mydashboard');
                                        }

                                        this.router.navigate(['/mydashboard']);
                                    }
                                }
                            }
                        } else {
                        }
                    },
                        (err: HttpErrorResponse) => {
                            this.global.globalSpinner = false;
                        });
                }
            }
        });

        if (this.user.status > 0) {
            if (this.user.status == 1 || this.user.status == 2) {
                this.global.activeNavTabs = 'dashboard';
            } else {
                this.global.activeNavTabs = '';
            }

            /************** Landing Page Logic ***********/
            const activeRouterPath = this.location.path();

            // console.log('activeRouterPath 1: ' + activeRouterPath);
            if (activeRouterPath == '' || activeRouterPath == '/') {
                // console.log('activeRouterPath 2: ' + activeRouterPath);
                if (this.user.status == 1 || this.user.status == 2) {
                    this.router.navigate(['/mydashboard']);
                } else {
                    this.router.navigate(['/songs']);
                }
            }
            /************** /Landing Page Logic ***********/

            this.sessionCheck();
            if (this.loadData) {
                if (this.global.isBrowser) {
                    // this.api.getScreenGuide('dashboard').subscribe(res => {
                    //     // console.log(res);
                    //     if (res.success) {
                    //         this.global.guides.dashboard = res.is_dashboard_sg_read;
                    //     }
                    // },
                    //     (err: HttpErrorResponse) => {
                    //     });

                    // this.api.getScreenGuide('claps').subscribe(res => {
                    //     // console.log(res);
                    //     if (res.success) {
                    //         this.global.guides.claps = res.is_claps_sg_read;
                    //     }
                    // },
                    //     (err: HttpErrorResponse) => {
                    //     });

                    // this.api.getScreenGuide('schedule').subscribe(res => {
                    //     // console.log(res);
                    //     if (res.success) {
                    //         this.global.guides.schedule = res.is_schedule_sg_read;
                    //     }
                    // },
                    //     (err: HttpErrorResponse) => {
                    //     });
                }
                this.getAgreements();
            }

            this.unreadMsgs();
            this.unreadNotificationsCount();


        }

        const angularthis = this;

        if (this.global.isBrowser) {
            // Check for new messages & notifications in 180sec interval
            setInterval(function () {
                if (angularthis.user.status > 0) {
                    angularthis.unreadMsgs();
                    angularthis.unreadNotificationsCount();
                }
            }, 180000);

            // Check session in 90sec interval
            setInterval(function () {
                if (angularthis.user.status > 0) {
                    angularthis.sessionCheck();
                }
            }, 90000);
        }
    }


    ngAfterViewInit() {
        this.router.events.subscribe(event => {
            if (event instanceof ActivationStart) {
                if (event.snapshot.params.slug !== undefined && event.snapshot.routeConfig.path == '') {
                    //this.loadData = false;
                    this.loadData = true;
                    this.sidenav.close()
                    // this.global.showPlayer = false;
                } else {
                    if (!this.global.isMobile()) {
                        this.sidenav.open()
                    }
                    // this.global.showPlayer = true;
                    this.loadData = true;

                }

                // Commented as by using it here, it was not giving updated SEO title
                 if (event instanceof NavigationEnd) {
                    setTimeout(() => {
                        (window as any).prerenderReady = true;
                        console.log('PRERENDER READY');
                    }, 5000); // increase if needed
                }
            }
            this.clearSearch();
        });
		if (!this.global.isMobile()) {
            this.sidenav.open();
        } else {
            this.sidenav.close();
        }
        if (!this.loadData) {
            this.getShoskeleBanner();
        }
    }

    // Open Visitor



    openVisitor() {
        this.isVisitStart = !this.isVisitStart;
        this.isMobileVisitStar = !this.isMobileVisitStar;
        this.mbaTextState = this.mbaTextState == 'large' ? 'small' : 'large';
        // console.log(this.mbaTextState)
    }

    openMobileVistitor() {
        this.isMobileVisitStar = !this.isMobileVisitStar;
        this.isVisitStart = !this.isVisitStart;
        this.mbaTextState = this.mbaTextState == 'large' ? 'small' : 'large';
        // console.log(this.mbaTextState)

    }



    scrollToMonetisation() {
        this.router.navigate(['/']);
        $(document).ready(() => {
            $('#monetisationPerformance')[0].scrollIntoView({ behavior: 'smooth' })

        })
    }

    scrollToDistribute() {
        this.router.navigate(['/']);
        $(document).ready(() => {
            $('#distributeRock')[0].scrollIntoView({ behavior: 'smooth' })
        })
    }
    scrollToPromote() {
        this.router.navigate(['/']);
        $(document).ready(() => {
            $('#promoteRock')[0].scrollIntoView({ behavior: 'smooth' })
        })
    }

    //get time in ago format
    getTimeInAgoFormat(time) {
        let time1 = new Date(time);
        let time2 = new Date();
        let diff = Math.abs(time2.getTime() - time1.getTime());
        let diffMinutes = Math.floor((diff / 1000) / 60);
        let diffHours = Math.floor(diffMinutes / 60);
        let diffDays = Math.floor(diffHours / 24);
        let diffWeeks = Math.floor(diffDays / 7);
        let diffMonths = Math.floor(diffWeeks / 4.35);
        let diffYears = Math.floor(diffMonths / 12);
        if (diffMinutes < 60) {
            return diffMinutes + " minutes ago";
        } else if (diffHours < 24) {
            return diffHours + " hours ago";
        } else if (diffDays < 7) {
            return diffDays + " days ago";
        } else if (diffWeeks < 4.35) {
            return diffWeeks + " weeks ago";
        } else if (diffMonths < 12) {
            return diffMonths + " months ago";
        } else {
            return diffYears + " years ago";
        }
    }

    onActivate(event) {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.available.subscribe(() => {
                if (confirm("New version available. Load New Version?")) {
                    window.location.reload();
                }
            });
        }

        // console.log('Router Changed', event);
        this.global.mainScrollablePos = 0;

        if (this.global.isBrowser) {
            $('.mainScrollable').animate({ scrollTop: 0 }, 0);
        }
        if (this.route.snapshot.firstChild.data.navigation_type != undefined && this.route.snapshot.firstChild.data.navigation_type == 'branding') {
            this.navigationType = 'branding';
        } else if (this.route.snapshot.firstChild.data.navigation_type != undefined && this.route.snapshot.firstChild.data.navigation_type == 'artist_pages') {
            this.global.pageType = '';
            if (this.location.path().indexOf('/distribute') > -1) {
                this.navigationType = '';
            } else {
                this.navigationType = 'artist_pages';
            }
        } else if (this.route.snapshot.firstChild.data.navigation_type != undefined && this.route.snapshot.firstChild.data.navigation_type == 'user-profile') {

            this.global.pageType = 'user-profile';
        } else {
            this.navigationType = '';
            this.global.pageType = '';
        }

        if (this.location.path().indexOf('/embed/') > -1) {
            this.embed = true;
        }

        if (this.route.snapshot.firstChild.data.footer != undefined && this.route.snapshot.firstChild.data.footer == false) {
            if (this.global.isBrowser) {
                $('.mainFooter').addClass('hidden');
            }
        } else {
            if (this.global.isBrowser) {
                $('.mainFooter').removeClass('hidden');
            }
        }

        if (this.route.snapshot.firstChild.data.header != undefined && this.route.snapshot.firstChild.data.header == false) {
            if (this.global.isBrowser) {
                $('.mainHeader').addClass('hidden');
            }
        } else {
            if (this.global.isBrowser) {
                $('.mainHeader').removeClass('hidden');
            }
        }


        this.getSchemaData();


        this.getShoskeleBanner();
        // show player only on specific routes; if hiding, pause playback
        try {
            const cleanUrl = this.router.url.split('?')[0];
            const showOn = ['/playlists', '/artists', '/library/favourites', '/library/playlists'];
            let show = false;
            for (const url of showOn) {
                if (cleanUrl === url || cleanUrl.startsWith(url + '/')) {
                    show = true;
                    break;
                }
            }
            this.global.showPlayer = show;
            if (!show && this.player && this.player.myPlaylist && this.player.playing) {
                try {
                    this.player.myPlaylist.pause();
                } catch (err) { }
                this.player.playing = false;
            }
        } catch (e) { this.global.showPlayer = false; }
        // control player visibility: show only on specific Discover pages
        try {
            const cleanUrl = this.router.url.split('?')[0];
            const showOn = ['/playlists', '/artists', '/library/favourites', '/library/playlists'];
            let show = false;
            for (const url of showOn) {
                if (cleanUrl === url || cleanUrl.startsWith(url + '/')) {
                    show = true;
                    break;
                }
            }
            this.global.showPlayer = show;
        } catch (e) {
            this.global.showPlayer = false;
        }
        const formRoute = ['songDisrtibute', 'song', 'album', 'apply', 'video', 'contact-us', 'filter', 'development']  // remove development while doing build live
        if (this.router.url.split('/')[3]) {
            // console.log('Activation take place active link')
            if (formRoute.includes(this.router.url.split('/')[3].split('?')[0])) {
                this.showWidget = false;
            } else {
                this.showWidget = true
            }

        } else if (this.router.url.split('/')[2]) {
            // console.log('Activation take place active link')
            if (formRoute.includes(this.router.url.split('/')[2].split('?')[0])) {
                this.showWidget = false;
            } else {
                this.showWidget = true
            }

        } else {
            if ((this.global.pageType == 'user-profile')) {
                this.showWidget = false
            } else {
                this.showWidget = true
            }
            // console.log('Activation take place else')
        }

    }

    scrolldown() {
        console.log("Page scroll Down")
    }
    scrollWin(x, y) {
        console.log("Move")
        window.scrollBy(x, y);
    }

    screenGuide() {

        const body = document.body,
            mainSection = document.querySelector('.newCAA');
        // mainSection.classList.remove('no-scroll');
        mainSection.classList.add('no-scroll');

        console.log("Screen Width", window.screen.width);

        if (window.screen.width < 768) {
            var loc = this.guidedTourComponent.progressIndicatorLocations.TopOfTourBlock;
            this.guidedTourService.startTour({
                tourId: 'tour',
                useOrb: false,
                // completeCallback: () => this.closeTour(),
                steps: [
                    // {
                    //     title: 'INTRO',
                    //     content: 'We have the concept of general page steps so that a you can introuce a user to a page or non specific instructions',
                    // },
                    {
                        title: '',
                        selector: '#first',
                        content: "Get access to Songdew's exclusive music marketing tools & push your music to more listeners.",
                        orientation: Orientation.Top,
                        action: () => {
                            document.getElementById("tour").scrollIntoView();

                        },

                    },
                    {
                        title: '',
                        selector: '#second',
                        content: "Get a curated list of over 30 opportunities every month to promote and monetize your music.",
                        orientation: Orientation.Bottom,
                        action: () => {
                            document.getElementById("first").scrollIntoView();

                        },
                    },
                    {
                        title: '',
                        selector: '#third',
                        content: "Make your music available on 150+ streaming & download services across 240 countries in no time.",
                        orientation: Orientation.Top,
                        action: () => {
                            document.getElementById("first").scrollIntoView();

                        },
                    },
                    {
                        title: '',
                        selector: '#fourth',
                        content: "Take your music to 200+ Mn Households through India's only music channel dedicated to independent music - Songdew TV.",
                        orientation: Orientation.Bottom,
                        action: () => {
                            document.getElementById("fourth").scrollIntoView();

                        },
                    },
                    {
                        title: '',
                        selector: '#fivth',
                        content: "Create your Custom Profile/ e-Press Kit & get discovered.",
                        orientation: Orientation.Top,
                        action: () => {
                            document.getElementById("fourth").scrollIntoView();

                        },

                    },
                    {
                        title: '',
                        selector: '#sixth',
                        content: "Confused, what to do next? Turn to Recommendations for help!",
                        orientation: Orientation.Bottom,
                        action: () => {
                            document.getElementById("sixth").scrollIntoView();
                        },

                    },
                    // {
                    //     title: '',
                    //     // selector: '#recomand',
                    //     content: 'Recommendations For you Widget',
                    //     orientation: Orientation.Top,

                    // }
                ]
            });

        } else if (window.screen.width < 1024) {
            var loc = this.guidedTourComponent.progressIndicatorLocations.TopOfTourBlock;
            this.guidedTourService.startTour({
                tourId: 'tour',
                useOrb: false,
                // completeCallback: () => this.closeTour(),
                steps: [
                    // {
                    //     title: 'INTRO',
                    //     content: 'We have the concept of general page steps so that a you can introuce a user to a page or non specific instructions',
                    // },
                    {
                        title: '',
                        selector: '#first',
                        content: "Get access to Songdew's exclusive music marketing tools & push your music to more listeners.",
                        orientation: Orientation.Top,

                    },
                    {
                        title: '',
                        selector: '#second',
                        content: "Get a curated list of over 30 opportunities every month to promote and monetize your music.",
                        orientation: Orientation.Bottom,
                        action: () => {
                            document.getElementById("first").scrollIntoView();

                        },

                    },
                    {
                        title: '',
                        selector: '#third',
                        content: "Make your music available on 150+ streaming & download services across 240 countries in no time.",
                        orientation: Orientation.Left,

                    },
                    {
                        title: '',
                        selector: '#fourth',
                        content: "Take your music to 200+ Mn Households through India's only music channel dedicated to independent music - Songdew TV.",
                        orientation: Orientation.Right,
                        action: () => {
                            document.getElementById("first").scrollIntoView();
                        },

                    },
                    {
                        title: '',
                        selector: '#fivth',
                        content: "Create your Custom Profile/ e-Press Kit & get discovered.",
                        orientation: Orientation.Top,
                        closeAction: () => {
                            document.getElementById("sixth").scrollIntoView();

                        },
                        action: () => {
                            document.getElementById("tour").scrollIntoView();
                        },



                    },
                    {
                        title: '',
                        selector: '#sixth',
                        content: "Confused, what to do next? Turn to Recommendations for help!",
                        orientation: Orientation.Bottom,
                        closeAction: () => {
                            document.getElementById("tour").scrollIntoView();

                        },


                    },
                    // {
                    //     title: '',
                    //     // selector: '#recomand',
                    //     content: 'Recommendations For you Widget',
                    //     orientation: Orientation.Right,

                    // }
                ]
            });

        } else {
            var loc = this.guidedTourComponent.progressIndicatorLocations.TopOfTourBlock;
            //console.log(loc)

            this.guidedTourService.startTour({
                tourId: 'tour',
                useOrb: false,
                // completeCallback: () => this.closeTour(),
                steps: [
                    // {
                    //     title: 'INTRO',
                    //     content: 'We have the concept of general page steps so that a you can introuce a user to a page or non specific instructions',
                    // },
                    {
                        title: '',
                        selector: '#first',
                        content: "Get access to Songdew's exclusive music marketing tools & push your music to more listeners.",
                        orientation: Orientation.Top,
                        action: () => {
                            document.getElementById("tour").scrollIntoView();

                        },

                    },
                    {
                        title: '',
                        selector: '#second',
                        content: "Get a curated list of over 30 opportunities every month to promote and monetize your music.",
                        orientation: Orientation.Left,
                        action: () => {
                            document.getElementById("first").scrollIntoView();

                        },
                    },
                    {
                        title: '',
                        selector: '#third',
                        content: "Make your music available on 150+ streaming & download services across 240 countries in no time.",
                        orientation: Orientation.Bottom,
                        action: () => {
                            document.getElementById("first").scrollIntoView();

                        },
                    },
                    {
                        title: '',
                        selector: '#fourth',
                        content: "Take your music to 200+ Mn Households through India's only music channel dedicated to independent music - Songdew TV.",
                        orientation: Orientation.Left,
                        action: () => {
                            document.getElementById("first").scrollIntoView();

                        },
                    },
                    {
                        title: '',
                        selector: '#fivth',
                        content: "Create your Custom Profile/ e-Press Kit & get discovered.",
                        orientation: Orientation.Bottom,
                        closeAction: () => {
                            document.getElementById("sixth").scrollIntoView();

                        },
                        action: () => {
                            document.getElementById("first").scrollIntoView();
                        },

                    },
                    {
                        title: '',
                        selector: '#sixth',
                        content: "Confused, what to do next? Turn to Recommendations for help!",
                        orientation: Orientation.Right,
                        closeAction: () => {
                            document.getElementById("tour").scrollIntoView();

                        },

                    },
                    // {
                    //     title: '',
                    //     // selector: '#recomand',
                    //     content: 'Recommendations For you Widget',
                    //     orientation: Orientation.Right,

                    // }
                ]
            });

        }

    }
    public clearSearch() {
        const angularThis = this;
        if (this.global.isBrowser) {
            clearTimeout(angularThis.searchApi);
            if (angularThis.searchSub) {
                angularThis.searchSub.unsubscribe();
                angularThis.searchResults = [];
            }
            $('.searchSpinner').hide();
        }
    }

    enterSearch() {
        this.clearSearch();
        if (this.search.length < 2) {
        } else {
            this.router.navigate(['/search'], { queryParams: { keywords: this.search, type: '' } });
        }
    }


    changeSearch(event) {
        if (event.keyCode != 13) {
            // console.log('change search');
            if (this.search.length < 2) {
                if (this.global.isBrowser) {
                    $('.searchSpinner').hide();
                }
                this.searchResults = [];
            } else {
                const angularThis = this;
                if (angularThis.searchSub) {
                    angularThis.searchSub.unsubscribe();
                }
                if (this.global.isBrowser) {
                    $('.searchSpinner').show();

                    clearTimeout(angularThis.searchApi);
                    angularThis.searchApi = setTimeout(function () {
                        angularThis.searchSub = angularThis.api.search(angularThis.search).subscribe(res => {
                            $('.searchSpinner').hide();
                            angularThis.searchResults = res.results.artist;
                            angularThis.searchResults = angularThis.searchResults.concat(res.results.album);
                            angularThis.searchResults = angularThis.searchResults.concat(res.results.music);
                            angularThis.searchResults = angularThis.searchResults.concat(res.results.video);
                            // console.log(angularThis.searchResults);
                        },
                            (err: HttpErrorResponse) => {
                                $('.searchSpinner').hide();
                                if (err.error instanceof Error) {
                                    // console.log('Client-side error occured!');
                                } else {
                                    // console.log('Server-side error occured!');
                                }
                            });
                    }, 1000);
                }
            }
        }
    }

    unreadMsgs() {
        if (this.global.isBrowser) {
            this.api.unreadMsgs().subscribe(res => {
                // console.log(res);

                this.showUnread = res.unread_count > 0 ? true : false;

            },
                (err: HttpErrorResponse) => {
                    $('#msgsCount').hide();
                    if (err.error instanceof Error) {
                        // console.log('Client-side error occured!');
                    } else {
                        // console.log('Server-side error occured!');
                    }
                });
        }
    }
    unreadNotificationsCount() {
        if (this.global.isBrowser) {
            this.api.unreadNotificationsCount().subscribe(res => {
                // console.log(res);
                this.noti_count = res.unread_count;
                this.brd_count = res.brd_count;

                // if (res.success && res.unread_count != 0) {
                //     // $('#notificationsCount').html(res.unread_count);
                //     //$('#notificationsCount').show();
                // } else {
                //     // $('#notificationsCount').hide();
                // }
            },
                (err: HttpErrorResponse) => {
                    $('#msgsCount').hide();
                    if (err.error instanceof Error) {
                        // console.log('Client-side error occured!');
                    } else {
                        // console.log('Server-side error occured!');
                    }
                });
        }
    }

    logout() {
        // console.log('Logging Out');
        this.global.activeNavTabs = '';

        this.api.logout().subscribe(res => {
            // console.log(res);

            this.user.status = 0;
            this.user.token = '';
            this.user.id = '0';
            this.user.type = 'Visitor';
            this.user.slug = '';
            this.user.fname = '';
            this.user.lname = '';
            this.user.name = '';
            this.user.dp = '';
            this.user.cover = '';
            this.user.genre = [];
            this.user.country = '';
            this.user.state = '';
            this.user.city = '';
            this.user.artistType = [];
            this.user.mobile = '';
            this.user.email = '';
            this.user.isProMember = 0;
            this.user.isEmailVerified = false;
            this.user.isMobVerified = false;
            this.user.songsCount = 0;
            this.user.videosCount = 0;
            this.user.isLabel = false;

            localStorage.removeItem('token');
            localStorage.removeItem('isProMember');
            localStorage.removeItem('id');
            localStorage.removeItem('type');
            localStorage.removeItem('slug');
            localStorage.removeItem('dp');
            localStorage.clear();


            this.router.navigate(['/404'], { skipLocationChange: true });
            this.router.navigate(['']);
        },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!');
                }

                this.user.status = 0;
                this.user.token = '';
                this.user.id = '0';
                this.user.type = 'Visitor';
                this.user.slug = '';
                this.user.fname = '';
                this.user.lname = '';
                this.user.name = '';
                this.user.dp = '';
                this.user.cover = '';
                this.user.genre = [];
                this.user.country = '';
                this.user.state = '';
                this.user.city = '';
                this.user.artistType = [];
                this.user.mobile = '';
                this.user.email = '';
                this.user.isEmailVerified = false;
                this.user.isMobVerified = false;
                this.user.songsCount = 0;
                this.user.videosCount = 0;

                localStorage.clear();
                localStorage.removeItem('token');
                localStorage.removeItem('id');
                localStorage.removeItem('type');
                localStorage.removeItem('slug');
                localStorage.removeItem('dp');

                this.router.navigate(['/404'], { skipLocationChange: true });
                this.router.navigate(['']);
            });
    }

    ngOnInit() {
        const angularthis = this;
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            const path = this.location.path();
            const canonicalUrl = `https://songdew.com${path || '/'}`;
            this.setCanonicalLink(canonicalUrl);
        });
        if (this.global.isBrowser) {

            setTimeout(function () {
                angularthis.player.initialisePlayer();
            }, 500);

            $('*').on('scroll', function () {
                if (angularthis.dialog.isDialogOpen('youtubeDialog')) {
                    // console.log('Resizing YT Dialog');
                    $('#youtubeDialog').addClass('resizeXS');
                }
            });

            $(document).on('click', '#menuButton', function () {
                $('#menu').toggleClass('opened-nav');
            });

            $(document).on('click', '.mainScrollable', function () {
                $('.queue').removeClass('active');
            });


            // Detect ios 11_0_x affected 
            // NEED TO BE UPDATED if new versions are affected 
            const ua = navigator.userAgent,
                iOS = /iPad|iPhone|iPod/.test(ua),
                iOS11 = /OS 11_0_1|OS 11_0_2|OS 11_0_3|OS 11_1|OS 11_2|OS 11_3/.test(ua);

            // ios 11 bug caret position
            if (iOS && iOS11) {
                // Add CSS class to body
                $('body').addClass('iosBugFixCaret');
            }

            if (/iP(hone|od|ad)/.test(navigator.platform)) {
                // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
                $('body').addClass('iosBugFixCaret');
            }
        }

        this.subIsVisitor = this.global.isVisitStart.subscribe(res => {
            this.isVisitStart = res;

        })
        this.subIsMobileVisitStar = this.global.isMobileVisitStar.subscribe(res => {
            this.isMobileVisitStar = res;

        })
        this.subWidgetStart = this.global.widgetStart.subscribe(res => {
            this.widgetStart = res;
        })



        // Set Cookie
        function setCookie(cname, cvalue, exdays) {
            if (exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 1000));
                var expires = "; expires=" + d.toUTCString();
                document.cookie = cname + '=' + (cvalue || '') + expires + ';';
            }
        }
        // Get Cookies
        function getCookie(cname) {
            const cookies = document.cookie.split(';');

            for (const cookie of cookies) {
                if (cookie.indexOf(cname + '=') > -1) {
                    return cookie.split('=')[1];
                }
            }

            return null;
        }


        // Exit Popup for Desktop

        function exitPopup(obj, evt, fn) {


        }
    }
    setCanonicalLink(url: string): void {
        let link: HTMLLinkElement = document.querySelector("link[rel='canonical']");
        if (link) {
            link.setAttribute('href', url);
        } else {
            link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', url);
            document.head.appendChild(link);
        }
    }

    changeArrow(event) {
        this.openDropdown = this.openDropdown === event ? null : event;
    }



    showsearch2() {
        $('.searchimg2').css("display", "none");
        $('.searchbaropp2').css("display", "block");



    }

    onClickedOutside2(e: Event) {
        $('.searchimg2').css("display", "block");
        $('.searchbaropp2').css("display", "none");
    }





    resizeOwlCarousels() {

        if (this.global.isBrowser) {
            setTimeout(() => {
                (<any>window).dispatchEvent(new Event('resize'));
            }, 500);
        }
    }

    toggleUserMenu() {
        if (this.global.isBrowser) {
            $('.userMenuMob').toggleClass('show');
        }
    }

    getNotifications() {
        this.notificationsLoaded = false;
        this.notifications = [];

        this.api.getNotifications(0, 2).subscribe(res => {
            // console.log(res);
            this.notificationsLoaded = true;
            this.notifications = res.results;
        },
            (err: HttpErrorResponse) => {
                this.notificationsLoaded = false;

                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!', err);
                }
            });
    }

    getSchemaData() {
        const currentPath = this.location.path() || '/';
        this.schemaData = this.schemaService.generateSchema(currentPath);
    }

    sessionCheck() {
        this.api.sessionCheck().subscribe(res => {
            // console.log(res);

            if (res.success) {
                this.user.category = res.category;
                this.user.token = 'Token ' + res.result.token;
                this.user.id = res.result.id;
                this.user.type = res.result.is_type;
                this.user.slug = res.result.slug_username;
                this.user.fname = res.result.profile.first_name;
                this.user.lname = res.result.profile.last_name;
                this.user.dp = res.result.profile.profile_pic;
                this.user.cover = res.result.profile.cover_pic;
                this.user.isProMember = res.result.is_pro;
                this.user.iswhatsapp_verify = res.result.iswhatsapp_verify;
                this.user.whatsapp_number = res.result.whatsapp_number;
                this.user.expdays = res.result.sds_e;
                this.user.isLabel = res.result.is_label;
                this.user.genre = [];
                res.result.genre_id.forEach(genre => {
                    this.user.genre.push(genre.name);
                });

                this.user.artistType = [];
                res.result.artist_type.forEach(type => {
                    this.user.artistType.push(type.name);

                    if (type.name.toLowerCase() == 'band') {
                        this.user.type = 'Band';
                    }
                });

                this.user.mobile = res.result.mobile;
                this.user.email = res.result.email;
                this.user.isEmailVerified = res.result.ismail_verify;
                this.user.isMobVerified = res.result.ismobile_verify;
                this.user.songsCount = res.result.songs_count;
                this.user.videosCount = res.result.videos_count;

                this.user.isPwdSet = res.result.has_usable_password;

                this.user.authorize_for_tv = res.result.authorize_for_tv;

                if (this.user.type == 'Band') {
                    this.user.status = 2;
                } else if (this.user.type == 'Artist') {
                    this.user.status = 1;
                } else if (this.user.type == 'Listener') {
                    this.user.status = 3;
                }

                this.user.name = this.user.fname + ' ' + this.user.lname;

                localStorage.setItem('category', JSON.stringify(this.user.category));
                localStorage.setItem('token', JSON.stringify(this.user.token));
                localStorage.setItem('id', JSON.stringify(this.user.id));
                localStorage.setItem('type', JSON.stringify(this.user.type));
                localStorage.setItem('slug', JSON.stringify(this.user.slug));
                localStorage.setItem('fname', JSON.stringify(this.user.fname));
                localStorage.setItem('lname', JSON.stringify(this.user.lname));
                localStorage.setItem('dp', JSON.stringify(this.user.dp));
                localStorage.setItem('cover', JSON.stringify(this.user.cover));
                localStorage.setItem('genre', JSON.stringify(this.user.genre));

                localStorage.setItem('artistType', JSON.stringify(this.user.artistType));
                localStorage.setItem('mobile', JSON.stringify(this.user.mobile));
                localStorage.setItem('email', JSON.stringify(this.user.email));
                localStorage.setItem('isEmailVerified', JSON.stringify(this.user.isEmailVerified));
                localStorage.setItem('isMobVerified', JSON.stringify(this.user.isMobVerified));
                localStorage.setItem('songsCount', JSON.stringify(this.user.songsCount));
                localStorage.setItem('videosCount', JSON.stringify(this.user.videosCount));
                localStorage.setItem('isPwdSet', JSON.stringify(this.user.isPwdSet));
                localStorage.setItem('isProMember', JSON.stringify(this.user.isProMember));
                localStorage.setItem('iswhatsapp_verify', JSON.stringify(this.user.iswhatsapp_verify));
                localStorage.setItem('whatsapp_number', JSON.stringify(this.user.whatsapp_number));
            } else {
                this.logout();
            }

            // if ( res.version > 101 ) {
            //     window.location.reload();
            // }
        },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    if (err.status == 401) {
                        this.logout();
                    }
                    // console.log('Server-side error occured!', err);
                }
            });
    }

    toggleActiveNavTabs() {
        if (this.user.status == 1 || this.user.status == 2) {
            if (this.global.activeNavTabs == 'dashboard') {
                this.global.activeNavTabs = '';
            } else {
                this.global.activeNavTabs = 'dashboard';
            }

            $('#LHSNavBar').animate({ scrollTop: 0 }, 100);
        } else {
            this.global.activeNavTabs = '';
        }
    }

    toggleSubMenu(event) {
        if (this.global.isBrowser) {
            const obj = $(event.target);
            obj.parent().toggleClass('active');
            obj.siblings().toggle();
        }
    }

    hideQueue() {
        if (this.global.isBrowser) {
            $('.queue').removeClass('active');
        }
    }

    getAgreements() {
        this.api.getAgreements(0, 10).subscribe(res => {
            if (res.result.length > 0) {
                this.global.agreements = true;
            }
        },
            (err: HttpErrorResponse) => {
            });
    }

    getShoskeleBanner() {
        if (!this.global.getCookie('shoskele_banner')) {
            this.api.advertisement('shoskele').subscribe(res => {
                if (res.success) {
                    if (res.media.length > 0) {

                        this.global.shoskeleBanner = this.shoskeleBanner = res.media[0];
                        this.shoskeleMedia = res.media;
                        this.global.Is_set_shoskeleBanner = true;
                        //this.showShoskele = true;

                        //this.global.setCookie('shoskele_banner', '1', 2);
                        this.loadShoskeleBanner();
                    }
                }
            },
                (err: HttpErrorResponse) => {
                });
        }
    }
    loadShoskeleBanner() {

        if (this.shoskeleTimeout) {
            clearTimeout(this.shoskeleTimeout);
        }


        let urt = this.router.url.split('?')[0].split('/')
       

        this.shoskeleMedia.forEach(ad => {
            let for_pro = ad.for_pro;
            if (this.global.getCookie('shoskele_banner')) {
               // || this.user.isProMember ==1
                //this.global.shoskeleBanner=this.shoskeleBanner = ad;
                //this.showShoskele = false;
            } else {
            
if(for_pro == 0 || (for_pro == 1 && this.user.isProMember == 1)){

		    if (ad && ad.adv_display_pages.includes('subscription') &&
		        this.router.url.split('?')[0] === '/subscription' ){
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		     

		     } else if (ad.adv_display_pages.includes('artist_dashboard') && this.router.url.split('?')[0] == '/mydashboard') {

                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);

		    }
		    else if (ad.adv_display_pages.includes('song_list') && (this.router.url.split('?')[0] == '/songs' || this.router.url.split('?')[0].indexOf('/songs/') !== -1) && (urt[1] != 'mydashboard')) {

                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    } else if (ad.adv_display_pages.includes('video_list') && (this.router.url.split('?')[0] == '/video-songs' || this.router.url.split('?')[0].indexOf('/video-songs/') !== -1)) {
		        this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
                } else if (ad.adv_display_pages.includes('opportunity_success') && ((urt[1] == 'opportunities' || urt[1] == 'opportunity') && urt[urt.length - 1] == 'success')) {

                    this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);

		    } else if (ad.adv_display_pages.includes('opportunity_detail') && (urt[1] == 'opportunities' && urt[2] != '')) {


		        this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);

		    } else if (ad.adv_display_pages.includes('opportunities_list') && this.router.url.split('?')[0] == '/opportunities') {
		        this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    } else if (ad.adv_display_pages.includes('upload_tracks') && (this.router.url.split('?')[0] == '/upload/song' || this.router.url.split('?')[0] == '/upload/tracks')) {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    } else if (ad.adv_display_pages.includes('upload_albums') && (this.router.url.split('?')[0] == '/upload/album' || this.router.url.split('?')[0] == '/upload/tracks')) {
		        this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    } else if (ad.adv_display_pages.includes('upload_videos') && (this.router.url.split('?')[0] == '/upload/video' || this.router.url.split('?')[0] == '/upload/videos' || this.router.url.split('?')[0] == '/upload/tracks')) {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    } else if (ad.adv_display_pages.includes('my_opportunities_detail') && this.router.url.split('?')[0] == '/mydashboard/opportunities') {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    } else if (ad.adv_display_pages.includes('my_music_detail') && (this.router.url.split('?')[0] == '/mydashboard/songs') && this.router.url.split('?')[1] === undefined) {
		        this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    } else if (ad.adv_display_pages.includes('my_videos') && (this.router.url.split('?')[0] == '/mydashboard/videos') && this.router.url.split('?')[1] === undefined) {
		        this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    }
		    else if (ad.adv_display_pages.includes('playlists_list') && (this.router.url.split('?')[0] == '/playlists')) {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    } else if (ad.adv_display_pages.includes('tv') && (this.router.url.split('?')[0] == '/songdew-tv')) {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    } else if (ad.adv_display_pages.includes('distribute') && (this.router.url.split('?')[0] == '/distribute' || this.router.url.split('?')[0] == '/distribute')) {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    }
		    else if (ad.adv_display_pages.includes('my_release') && this.router.url.split('?')[0] == '/distribute/my-releases') {
		        this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    }
		    else if (ad.adv_display_pages.includes('artists_list') && this.router.url.split('?')[0] == '/artists') {
		        this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    }

		    else if (ad.adv_display_pages.includes('analytics_detail') && this.router.url.split('?')[0] == '/mydashboard/analytics') {
		        this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    }

		    /*else if (ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[1] !== undefined) {
		        if (this.router.url.split('?')[1].split('=')[0] == 'tab') {
                    this.global.shoskeleBanner=this.shoskeleBanner = ad;
		            this.shoskeleTimeout = setTimeout(() => {
		                this.showShoskele = true;
		                this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		            }, +ad.start_time * 1000);
		        }
		    }*/

		    else if (ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
		        this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    }

		    else if (ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/achievements') {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    }



		    else if (ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
		    }
            else if ( ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
            }else if ( ad.adv_display_pages.includes('pro_perks') && this.router.url.split('?')[0] == '/pro-perks') {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
            }else if ( ad.adv_display_pages.includes('promote') && this.router.url.split('?')[0] == '/promote') {
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
            }else if(ad.adv_display_pages.includes('dist_succ_single') && this.router.url.split('?')[0] == '/distribute/music/song' ){
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
            }else if(ad.adv_display_pages.includes('achievements_detail') && this.router.url.split('?')[0] == '/mydashboard/achievements' ){
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
            }else if(ad.adv_display_pages.includes('dist_succ_album') && this.router.url.split('?')[0] == '/distribute/music/album' ){
                this.global.shoskeleBanner=this.shoskeleBanner = ad;
		        this.shoskeleTimeout = setTimeout(() => {
		            this.showShoskele = true;
		            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
		        }, +ad.start_time * 1000);
            }

           
} else if(for_pro == 2 && this.user.isProMember != 1){
        if (ad && ad.adv_display_pages.includes('subscription') &&
        this.router.url.split('?')[0] === '/subscription' ){
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
     

     } else if (ad.adv_display_pages.includes('artist_dashboard') && this.router.url.split('?')[0] == '/mydashboard') {

        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);

    }
     else if (ad.adv_display_pages.includes('song_list') && (this.router.url.split('?')[0] == '/songs' || this.router.url.split('?')[0].indexOf('/songs/') !== -1) && (urt[1] != 'mydashboard')) {

        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    } else if (ad.adv_display_pages.includes('video_list') && (this.router.url.split('?')[0] == '/video-songs' || this.router.url.split('?')[0].indexOf('/video-songs/') !== -1)) {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
        } else if (ad.adv_display_pages.includes('opportunity_success') && ((urt[1] == 'opportunities' || urt[1] == 'opportunity') && urt[urt.length - 1] == 'success')) {

            this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);

    } else if (ad.adv_display_pages.includes('opportunity_detail') && (urt[1] == 'opportunities' && urt[2] != '')) {


        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);

    } else if (ad.adv_display_pages.includes('opportunities_list') && this.router.url.split('?')[0] == '/opportunities') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    } else if (ad.adv_display_pages.includes('upload_tracks') && (this.router.url.split('?')[0] == '/upload/song' || this.router.url.split('?')[0] == '/upload/tracks')) {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    } else if (ad.adv_display_pages.includes('upload_albums') && (this.router.url.split('?')[0] == '/upload/album' || this.router.url.split('?')[0] == '/upload/tracks')) {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    } else if (ad.adv_display_pages.includes('upload_videos') && (this.router.url.split('?')[0] == '/upload/video' || this.router.url.split('?')[0] == '/upload/videos' || this.router.url.split('?')[0] == '/upload/tracks')) {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    } else if (ad.adv_display_pages.includes('my_opportunities_detail') && this.router.url.split('?')[0] == '/mydashboard/opportunities') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    } else if (ad.adv_display_pages.includes('my_music_detail') && (this.router.url.split('?')[0] == '/mydashboard/songs') && this.router.url.split('?')[1] === undefined) {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    } else if (ad.adv_display_pages.includes('my_videos') && (this.router.url.split('?')[0] == '/mydashboard/videos') && this.router.url.split('?')[1] === undefined) {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }
    else if (ad.adv_display_pages.includes('playlists_list') && (this.router.url.split('?')[0] == '/playlists')) {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    } else if (ad.adv_display_pages.includes('tv') && (this.router.url.split('?')[0] == '/songdew-tv')) {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    } else if (ad.adv_display_pages.includes('distribute') && (this.router.url.split('?')[0] == '/distribute' || this.router.url.split('?')[0] == '/distribute')) {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }
    else if (ad.adv_display_pages.includes('my_release') && this.router.url.split('?')[0] == '/distribute/my-releases') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }
    else if (ad.adv_display_pages.includes('artists_list') && this.router.url.split('?')[0] == '/artists') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }

    else if (ad.adv_display_pages.includes('analytics_detail') && this.router.url.split('?')[0] == '/mydashboard/analytics') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }

    /*else if (ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[1] !== undefined) {
        if (this.router.url.split('?')[1].split('=')[0] == 'tab') {
            this.global.shoskeleBanner=this.shoskeleBanner = ad;
            this.shoskeleTimeout = setTimeout(() => {
                this.showShoskele = true;
                this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
            }, +ad.start_time * 1000);
        }
    }*/

    else if (ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }

    else if (ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/achievements') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }



    else if (ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }
    else if (ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }
    else if ( ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }else if ( ad.adv_display_pages.includes('pro_perks') && this.router.url.split('?')[0] == '/pro-perks') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }else if ( ad.adv_display_pages.includes('promote') && this.router.url.split('?')[0] == '/promote') {
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }else if(ad.adv_display_pages.includes('dist_succ_single') && this.router.url.split('?')[0] == '/distribute/music/song' ){
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }else if(ad.adv_display_pages.includes('achievements_detail') && this.router.url.split('?')[0] == '/mydashboard/achievements' ){
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }else if(ad.adv_display_pages.includes('dist_succ_album') && this.router.url.split('?')[0] == '/distribute/music/album' ){
        this.global.shoskeleBanner=this.shoskeleBanner = ad;
        this.shoskeleTimeout = setTimeout(() => {
            this.showShoskele = true;
            this.global.setCookie('shoskele_banner', '1', +ad.end_time / 60 / 60 / 24);
        }, +ad.start_time * 1000);
    }


    }
            }
            
        });
    }

    openHomePage() {
        this.global.pageType = '';
        this.sidenav.open();
        this.router.navigate(['']);

    }
}
